define("shared/utils/formatters/ig-reel-from-dynamo", ["exports", "later/models/ig-reel", "@ember/utils"], function (_exports, _igReel, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/models/ig-reel",0,"@ember/utils"eaimeta@70e063a35619d71f

  /**
   * Converts a raw dynamo post into an igReel
   *
   * @method createIgReelFromDynamo
   * @param {Object} obj Raw dynamo post
   * @param {SocialProfile} socialProfile The social profile for the post
   *
   * @returns {IgReel} Returns an igReel
   */
  function createIgReelFromDynamo(obj, socialProfile) {
    const attrs = {};
    attrs.timeCollected = Date.now();
    attrs.hasMedia = true;
    attrs.socialProfile = socialProfile;
    attrs.id = obj.id;
    attrs.createdTime = Number(obj.created_time);
    attrs.type = obj.type;
    attrs.isStory = false;
    attrs.isCarousel = obj.type === 'carousel';
    attrs.isDeleted = obj.is_deleted;
    attrs.thumbUrl = obj.permanent_image_url || obj.image_square_url;
    attrs.imageUrl = obj.permanent_image_url || obj.image_medium_url || obj.image_square_url;
    const reach = obj.carousel_album_reach || obj.reach;
    attrs.reach = reach ? Number(reach) : reach;
    const savedCount = obj.carousel_album_saved || obj.saved;
    attrs.savedCount = savedCount ? Number(savedCount) : savedCount;
    const {
      plays
    } = obj;
    attrs.plays = plays ? Number(plays) : plays;

    if (!(0, _utils.isNone)(obj.shares)) {
      attrs.shareCount = Number(obj.shares);
    }

    if (!(0, _utils.isNone)(obj.comment_count)) {
      attrs.commentCount = Number(obj.comment_count);
    }

    if (!(0, _utils.isNone)(obj.like_count)) {
      attrs.likeCount = Number(obj.like_count);
    }

    if (!(0, _utils.isNone)(obj.image_medium_url)) {
      attrs.standardResUrl = obj.image_medium_url;
    }

    if (!(0, _utils.isNone)(obj.link)) {
      attrs.instagramLink = obj.link;
    }

    if (!(0, _utils.isNone)(obj.caption)) {
      attrs.caption = obj.caption;
    }

    if (!(0, _utils.isNone)(obj.media_product_type)) {
      attrs.mediaProductType = obj.media_product_type;
    }

    return _igReel.default.create(attrs);
  }

  var _default = createIgReelFromDynamo;
  _exports.default = _default;
});